import React from "react";
import PropTypes from "prop-types";

export default function LeftBodyPane({
  styles,
  leftBodyRef,
  fixedColumns,
  fixedPaneWidth,
  height,
  ROW_HEIGHT,
  totalRow,
  rows,
  formatValue
}) {
  const getRowKey = (row, index) =>
    // Try to find a unique identifier in order of preference
    row?.id ??
    row?.Id ??
    // Fallback to combining multiple fields for uniqueness
    (row?.["Basepack Desc"] ? `${row.Basepack}_${row["Basepack Desc"]}_${index}` : undefined) ??
    row?.Basepack ??
    row?.BG ??
    row?.Format ??
    // Last resort: use stringified object with index (includes all data)
    `row_${index}_${JSON.stringify(row)}`;

  return (
    <div
      ref={leftBodyRef}
      className={styles.hideScrollbar}
      style={{
        position: "sticky",
        left: 0,
        zIndex: 20,
        display: "block",
        width: `${fixedPaneWidth}px`,
        minWidth: `${fixedPaneWidth}px`,
        maxWidth: `${fixedPaneWidth}px`,
        background: "#FFFFFF",
        borderRight: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "3px 0 0 rgba(0,0,0,0.02)",
        height: typeof height === "number" ? `${height}px` : height,
        overflowY: "auto",
        overflowX: "hidden"
      }}
    >
      {totalRow && (
        <div style={{ display: "flex", background: "#F6F7F0" }}>
          {fixedColumns.map((col, cIndex) => (
            <div
              key={`total-left-${col.label}`}
              style={{
                height: ROW_HEIGHT,
                lineHeight: `${ROW_HEIGHT}px`,
                padding: "0 10px",
                flex: `0 0 ${col.width || 100}px`,
                minWidth: `${col.width || 100}px`,
                maxWidth: `${col.width || 100}px`,
                borderBottom: "1px solid #E2E8F5",
                borderRight: "1px solid #E6ECFA",
                boxSizing: "border-box",
                fontWeight: 600,
                fontSize: "13px",
                color: "#1F2937",
                fontFamily:"Unilever Shilling"
              }}
              title={cIndex === 0 ? "TOTAL" : ""}
            >
              {cIndex === 0 ? "TOTAL" : ""}
            </div>
          ))}
        </div>
      )}

      {rows.map((row, index) => (
        <div key={`fixed-left-row-${getRowKey(row, index)}`} className={styles.fixedLeftRow}>
          {fixedColumns.map((col, cIndex) => {
            const rawVal = row?.[col.label];

            const val =
              col.label === "Basepack"
                ? rawVal ?? "-"
                : formatValue(rawVal);

            const isNumber = typeof rawVal === "number";
            const width = col.width || 100;

            return (
              <div
                key={`fixed-body-cell-${getRowKey(row, index)}-${col.label}`}
                className={styles.fixedLeftCell}
                style={{
                  height: ROW_HEIGHT,
                  lineHeight: `${ROW_HEIGHT}px`,
                  flex: `0 0 ${width}px`,
                  minWidth: `${width}px`,
                  maxWidth: `${width}px`,
                  textAlign: isNumber ? "right" : "left"
                }}
                title={
  typeof rawVal?.value === "number"
    ? rawVal.value.toLocaleString("en-IN")
    : rawVal?.value ?? rawVal ?? "-"
}
              >
                {val}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

LeftBodyPane.propTypes = {
  styles: PropTypes.object,
  leftBodyRef: PropTypes.object,
  fixedColumns: PropTypes.array,
  fixedPaneWidth: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ROW_HEIGHT: PropTypes.number,
  totalRow: PropTypes.object,
  rows: PropTypes.array,
  formatValue: PropTypes.func,
};